
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator"

export const DEFAULT_PICKER_COLOR = "#009acc" // Couleur par défaut

@Component({})
export default class ColorPicker extends Vue {
  @Prop() value?: string

  selectedColor = DEFAULT_PICKER_COLOR

  mounted(): void {
    this.updateValue()
  }

  @Watch("value")
  updateValue(): void {
    this.selectedColor = this.value ? this.value : ""
    this.$emit("update-value", this.selectedColor)
  }

  @Watch("selectedColor")
  updateSelectedColor(color: any | string): void {
    this.selectedColor = color + ""
    this.$emit("update-value", this.selectedColor)
  }

  resetColor(): void {
    this.selectedColor = ""
  }
}
